import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  MenuOutlined,
  CloseOutlined,
  HomeOutlined,
  DollarOutlined,
  RetweetOutlined,
  UserOutlined,
  DeliveredProcedureOutlined,
  SnippetsOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Button,
  Drawer,
  Image,
  Layout,
  Menu,
  Modal,
  theme,
  Tooltip,
  Typography,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CustomerOrderInfo, PermissionInfo, UserInfo } from "../../context";
import "./layout.css";
import ImgLogo from "./../../assets/tinyimg/logo.webp";
import DialogSubmitCashCountToLogout from "../../utils/merchant-employee/DialogSubmitCashCountToLogout";

const { Header, Sider, Content, Footer } = Layout;

const MerchantEmployeeLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(
    window.innerWidth > 600 ? false : true
  );
  const navtab =
    window.location.pathname === "/"
      ? "1"
      : window.location.pathname === "/waiting"
      ? "2"
      : window.location.pathname === "/production"
      ? "3"
      : window.location.pathname === "/now-serving"
      ? "4"
      : window.location.pathname === "/waiter"
      ? "5"
      : window.location.pathname === "/pay-later"
      ? "6"
      : window.location.pathname === "/cash-count"
      ? "7"
      : window.location.pathname === "/products"
      ? "8"
      : window.location.pathname === "/employee-permissions"
      ? "9"
      : window.location.pathname === "/report"
      ? "10"
      : window.location.pathname === "/to-bill-out"
      ? "11"
      : window.location.pathname === "/tl/cash-count"
      ? "12"
      : window.location.pathname === "/inventory-report"
      ? "13"
      : window.location.pathname === "/other-transaction"
      ? "14"
      : window.location.pathname === "/additional-services"
      ? "15"
      : window.location.pathname === "/account-receivable"
      ? "16"
      : window.location.pathname === "/accounting/report"
      ? "17"
      : window.location.pathname === "/house-keeping/room-status"
      ? "18"
      : window.location.pathname === "/accounting/expense"
      ? "19"
      : "";
  const openTabKeys = ["sub1", "sub2", "sub3", "sub4"];
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const themeStyle = "dark";
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { handleLogoutTkn, userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const { permissionList } = useContext(PermissionInfo);
  const [openLogoutRestrict, setOpenLogoutRestrict] = useState(false);

  const {
    merchantOrderSaveList,
    nowServingList,
    toProductionList,
    merchantPayLaterList,
    dailyCashFundList,
    additionalService,
  } = useContext(CustomerOrderInfo);

  function getItem(label, key, icon, children, disabled, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
      disabled,
    };
  }

  // console.log("additionalService: ", additionalService);

  const items = [
    getItem(
      <Link to="/" relative="path">
        Home
      </Link>,
      "1",
      <HomeOutlined />
    ),
    //CASHIERING
    permissionList.ready &&
    parseInt(permissionList.data.merchant_info.is_production) === 1 &&
    permissionList.data.result.find(
      ({ permission }) => permission === "cashiering"
    )
      ? getItem(
          "Cashiering",
          "sub1",
          !openDrawer && collapsed ? (
            <Badge
              count={
                merchantOrderSaveList.data.length +
                nowServingList.data.length +
                merchantPayLaterList.data.length
              }
              size="small"
              style={{ marginRight: -10, marginTop: 10 }}
            >
              <DollarOutlined />
            </Badge>
          ) : (
            <DollarOutlined />
          ),
          [
            //WAITING
            getItem(
              <Link to="/waiting" relative="path">
                <Badge
                  count={merchantOrderSaveList.data.length}
                  size="small"
                  style={{ marginRight: -52, marginTop: 10 }}
                >
                  <Typography style={{ color: "#fff" }}>Waiting</Typography>
                </Badge>
              </Link>,
              "2",
              "",
              ""
            ),
            //PAY LATER
            getItem(
              <Link to="/pay-later" relative="path">
                <Badge
                  count={merchantPayLaterList.data.length}
                  size="small"
                  style={{ marginRight: -20, marginTop: 10 }}
                >
                  <Typography style={{ color: "#fff" }}>Pay Later</Typography>
                </Badge>
              </Link>,
              "6",
              "",
              ""
            ),
            //ADDITIONAL SERVICES
            getItem(
              <Link to="/additional-services" relative="path">
                <Badge
                  count={additionalService.data.length}
                  size="small"
                  style={{ marginRight: -9, marginTop: 10 }}
                >
                  <Typography style={{ color: "#fff" }}>
                    Additional Service
                  </Typography>
                </Badge>
              </Link>,

              // <Link to="/additional-services" relative="path">
              //   <Typography
              //     style={{
              //       color: "#fff",
              //       marginTop: !openDrawer && collapsed ? 10 : 0,
              //     }}
              //   >
              //     Additional Services
              //   </Typography>
              // </Link>,

              "15",
              "",
              ""
            ),
            //ACCOUNT RECEIVABLE
            getItem(
              <Link to="/account-receivable" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Account Receivable
                </Typography>
              </Link>,
              "16",
              "",
              ""
            ),
            //NOW SERVING
            getItem(
              <Link to="/now-serving" relative="path">
                <Badge
                  count={nowServingList.data.length}
                  size="small"
                  style={{ marginRight: -20, marginTop: 10 }}
                >
                  <Typography style={{ color: "#fff" }}>Now Serving</Typography>
                </Badge>
              </Link>,
              "4",
              "",
              ""
            ),
            //OTHER TRANSACTION
            getItem(
              <Link to="/other-transaction" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Other Transaction
                </Typography>
              </Link>,
              "14",
              "",
              ""
            ),
            //CASH COUNT
            getItem(
              <Link to="/cash-count" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Cash Count
                </Typography>
              </Link>,
              "7",
              "",
              ""
            ),
          ],
          permissionList.data.result.find(
            ({ permission }) => permission === "cashiering"
          )
            ? false
            : true
        )
      : null,
    //PRODUCTION
    permissionList.ready &&
      parseInt(permissionList.data.merchant_info.is_production) === 1 &&
      permissionList.data.result.find(
        ({ permission }) => permission === "production"
      ) &&
      getItem(
        <Link to="/production" relative="path">
          <Badge
            count={toProductionList.data.length}
            size="small"
            style={{ marginRight: -20, marginTop: 10 }}
          >
            <Typography style={{ color: "#fff" }}>Production</Typography>
          </Badge>
        </Link>,
        "3",
        !openDrawer && collapsed ? (
          <Badge
            count={toProductionList.data.length}
            size="small"
            style={{ marginRight: -10, marginTop: 10 }}
          >
            <RetweetOutlined />
          </Badge>
        ) : (
          <RetweetOutlined />
        ),
        ""
      ),
    //WAITER
    permissionList.ready &&
    parseInt(permissionList.data.merchant_info.is_production) === 1 &&
    permissionList.data.result.find(({ permission }) => permission === "waiter")
      ? getItem(
          "Waiter",
          "sub3",
          <DeliveredProcedureOutlined />,
          [
            getItem(
              <Link to="/waiter" relative="path">
                <Badge
                  count={nowServingList.data.length}
                  size="small"
                  style={{ marginRight: -20, marginTop: 10 }}
                >
                  <Typography
                    style={{
                      color: "#fff",
                      marginTop: !openDrawer && collapsed ? 10 : 0,
                    }}
                  >
                    To Serve
                  </Typography>
                </Badge>
              </Link>,
              "5",
              "",
              ""
            ),
            getItem(
              <Link to="/to-bill-out" relative="path">
                {/* <Badge
                  count={nowServingList.data.length}
                  size="small"
                  style={{ marginRight: -20, marginTop: 10 }}
                > */}
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  To Bill Out
                </Typography>
                {/* </Badge> */}
              </Link>,
              "11",
              "",
              ""
            ),
          ],
          permissionList.data.result.find(
            ({ permission }) => permission === "waiter"
          )
            ? false
            : true
        )
      : null,
    //TEAM LEADER
    permissionList.ready &&
    parseInt(permissionList.data.merchant_info.is_production) === 1 &&
    permissionList.data.result.find(
      ({ permission }) => permission === "team-leader"
    )
      ? getItem(
          "Team Leader",
          "sub2",
          <UserOutlined />,
          [
            getItem(
              <Link to="/waiting" relative="path">
                <Badge
                  count={merchantOrderSaveList.data.length}
                  size="small"
                  style={{ marginRight: -52, marginTop: 10 }}
                >
                  <Typography style={{ color: "#fff" }}>Waiting</Typography>
                </Badge>
              </Link>,
              "2",
              "",
              ""
            ),
            getItem(
              <Link to="/products" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Products
                </Typography>
              </Link>,
              "8",
              "",
              ""
            ),
            getItem(
              <Link to="/employee-permissions" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Permissions
                </Typography>
              </Link>,
              "9",
              "",
              ""
            ),
            getItem(
              <Link to="/report" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Report
                </Typography>
              </Link>,
              "10",
              "",
              ""
            ),
            getItem(
              <Link to="/tl/cash-count" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Cash Count
                </Typography>
              </Link>,
              "12",
              "",
              ""
            ),
          ],
          permissionList.data.result.find(
            ({ permission }) => permission === "team-leader"
          )
            ? false
            : true
        )
      : null,
    //ACCOUNTING
    permissionList.ready &&
    parseInt(permissionList.data.merchant_info.is_production) === 1 &&
    permissionList.data.result.find(
      ({ permission }) => permission === "accounting"
    )
      ? getItem(
          "Accounting",
          "sub4",
          <SnippetsOutlined />,
          [
            getItem(
              <Link to="/accounting/report" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Report
                </Typography>
              </Link>,
              "17",
              "",
              ""
            ),
            getItem(
              <Link to="/accounting/expense" relative="path">
                <Typography
                  style={{
                    color: "#fff",
                    marginTop: !openDrawer && collapsed ? 10 : 0,
                  }}
                >
                  Expense
                </Typography>
              </Link>,
              "19",
              "",
              ""
            ),
          ],
          permissionList.data.result.find(
            ({ permission }) => permission === "accounting"
          )
            ? false
            : true
        )
      : null,
    // ? getItem(
    //     <Link to="/accounting/report" relative="path">
    //       Report
    //     </Link>,
    //     "17",
    //     <SnippetsOutlined />
    //   )
    // : null,
    permissionList.ready &&
    parseInt(permissionList.data.merchant_info.is_production) === 1 &&
    permissionList.data.result.find(
      ({ permission }) => permission === "house-keeping"
    )
      ? getItem(
          <Link to="/house-keeping/room-status" relative="path">
            House Keeping
          </Link>,
          "18",
          <SnippetsOutlined />
        )
      : null,
    //INVENTORY REPORT
    permissionList.ready &&
    parseInt(permissionList.data.merchant_info.is_production) === 1 &&
    permissionList.data.result.find(
      ({ permission }) => permission === "inventory-report"
    )
      ? getItem(
          <Link to="/inventory-report" relative="path">
            Inventory Report
          </Link>,
          "13",
          <SnippetsOutlined />
        )
      : null,
  ];

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
      handleLogoutTkn();
    }, 2000);
  };

  return (
    <Layout
      style={{ minHeight: "100vh" }}
      hasSider={window.innerWidth > 500 ? true : false}
    >
      {window.innerWidth > 500 && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: themeStyle === "dark" ? "#001529" : "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: collapsed ? 45 : 100,
                width: collapsed ? 45 : 100,
                margin: 16,
                background: themeStyle === "dark" ? "transparent" : "#001529",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Image
                width={"auto"}
                height={collapsed ? 45 : 100}
                src={
                  userData.data.usersmerchantemployee.business_logo !== null
                    ? `${import.meta.env.VITE_API_IMAGE}logo/${
                        userData.data.usersmerchantemployee.business_logo
                      }`
                    : ImgLogo
                }
                placeholder={"logo"}
                preview={false}
                alt="logo"
              />
            </div>
          </div>
          <Menu
            defaultSelectedKeys={[navtab]}
            defaultOpenKeys={openTabKeys}
            mode="inline"
            theme="dark"
            items={items}
          />
          {/* qweqwe */}
        </Sider>
      )}

      <Layout
        className="container3"
        style={{
          marginLeft: window.innerWidth > 500 ? (collapsed ? 80 : 200) : 0,
        }}
      >
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ flexGrow: 1 }}>
              {window.innerWidth > 500 ? (
                collapsed ? (
                  <MenuUnfoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                ) : (
                  <MenuFoldOutlined
                    style={{ marginLeft: 10, fontSize: 15 }}
                    className="trigger"
                    onClick={() => setCollapsed(!collapsed)}
                  />
                )
              ) : (
                <MenuOutlined
                  style={{ marginLeft: 10, fontSize: 15 }}
                  className="trigger"
                  onClick={() => setOpenDrawer(!openDrawer)}
                />
              )}
              {/* EMPLOYEE NAME */}
              {/* <Typography style={{ marginLeft: 10 }}> */}
              <span style={{ marginLeft: 10 }}>
                {userData.data.usersmerchantemployee.firstname}
              </span>
              {/* </Typography> */}
            </div>
            <div style={{ marginRight: 20 }}>
              <Tooltip
                placement="bottomRight"
                title={"Logout"}
                color={"#2db7f5"}
              >
                {/* {console.log(
                  permissionList.data.result.find(
                    ({ permission }) => permission === "cashiering"
                  ) !== null
                )} */}
                <LogoutOutlined
                  style={{ fontSize: 15 }}
                  className="trigger"
                  onClick={() => {
                    if (
                      permissionList.ready &&
                      permissionList.data.result.find(
                        ({ permission }) => permission === "cashiering"
                      )
                    ) {
                      if (
                        dailyCashFundList.ready &&
                        parseInt(dailyCashFundList.data.my_daily_not_done) < 1
                      ) {
                        setOpen(true);
                      } else {
                        setOpenLogoutRestrict(true);
                      }
                    } else {
                      setOpen(true);
                    }
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            overflow: "initial",
          }}
        >
          {children}
        </Content>
        <Footer
          style={{
            textAlign: "center",
            fontWeight: "bold",
            width: "100%",
            position: "inherit",
            marginBottom: 0,
          }}
        >
          DigiMenu ©2023 Created by Nehemiah Solutions
        </Footer>
      </Layout>

      <Drawer
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
        placement="left"
        closable={false}
        bodyStyle={{ backgroundColor: "#001529" }}
        width={230}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div style={{ flexGrow: 1 }}></div>
          <div>
            <Tooltip title="Close">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setOpenDrawer(false);
                }}
                style={{ color: "#fff", backgroundColor: "#001529" }}
                icon={<CloseOutlined />}
              />
            </Tooltip>
          </div>
        </div>
        <Menu
          defaultSelectedKeys={[navtab]}
          defaultOpenKeys={["sub1", "sub2", "sub3"]}
          // mode="inline"
          theme="dark"
          items={items}
        />
      </Drawer>

      <Modal
        title="Are you sure to logout?"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpen(false)}
        centered
      />

      {openLogoutRestrict && (
        <DialogSubmitCashCountToLogout
          open={openLogoutRestrict}
          close={() => {
            setOpenLogoutRestrict(false);
          }}
        />
      )}
    </Layout>
  );
};
export default MerchantEmployeeLayout;
